import React from 'react'
import Layout from 'component/Layout'
import Banner from 'component/Banner'
import IntercomChatProvider from 'component/IntercomChatProvider'

import Hero from 'pageComponent/componentsHomePage/Hero'
import AstreaSection from 'pageComponent/componentsHomePage/AstreaSection'
import ThemisSection from 'pageComponent/componentsHomePage/ThemisSection'
import SocialProof from 'pageComponent/componentsHomePage/SocialProof'
import AurumNaMidia from 'pageComponent/componentsHomePage/AurumNaMidia'
import ContentSection from 'pageComponent/componentsHomePage/ContentSection'
import FaqSection from 'pageComponent/componentsHomePage/FaqSection'
// import SummitSection from 'pageComponents/componentsHomePage/SummitSection' // Não deletar

import { Script } from 'gatsby'

import 'theme/homePage.scss'

const IndexPage = () => {
	return (
		<Layout>
			<main className="home">
				<Hero />
				<AstreaSection />
				<ThemisSection />
				<aside>
					<SocialProof />
					<AurumNaMidia />
				</aside>
			</main>
			<aside className="home">
				<ContentSection />
				<FaqSection />
				{/* <SummitSection /> */}
				<Banner
					suptitle={'Aproveite!'}
					title={'Modernize sua advocacia com o melhor custo-benefício!'}
					text={
						<>
							O Astrea é o software jurídico ideal para gestão de escritórios de
							advocacia e advogados autônomos. Completo e fácil de usar,
							acompanha o crescimento do seu negócio desde o início!
						</>
					}
					btnClass={'astreaReverse'}
					linkhref={'/astrea/'}
					linktext={'Conheça tudo sobre o Astrea'}
					theme={'astrea'}
				/>
			</aside>
			<IntercomChatProvider />
		</Layout>
	)
}

export default IndexPage

export const Head = () => {
	let schema = {
		'@context': 'https://schema.org',
		'@type': 'WebSite',
		'name': 'Aurum',
		'alternateName': 'Aurum Software',
		'url': 'https://www.aurum.com.br/',
	}

	let title = 'Astrea: Software Jurídico para Advogados (Teste Grátis)'
	let metaDescription =
		'Software jurídico é um programa de computador desenvolvido para atender advogados e escritórios de advocacia. Conheça o Astrea e o Themis!'

	return (
		<>
			<html lang="pt-br" />
			<title>{title}</title>
			<meta name="description" content={metaDescription} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={metaDescription} />
			<meta property="og:type" content="website" />
			<meta property="twitter:card" content="summary" />
			<meta property="twitter:title" content={title} />
			<meta property="twitter:description" content={metaDescription} />
			<Script type="application/ld+json">{JSON.stringify(schema)}</Script>
		</>
	)
}
